/**
* Returns the status message for the product
* @param {Array} features - Features array from the product
* @param {String} type - product type
* @param {Boolean} ubisoftSka - Ubisoft ska status
* @param {Boolean} originSka - Origin ska status
* @param {Boolean} epicSka - Epic ska status
* @param {Array} validDrm - formatted Valid DRM array from product
* @param {String} slug - product slug
* @returns {Array} - Returns the status message for the product
*/
const getStatusMessage = (features, type, ubisoftSka, originSka, epicSka, validDrm, slug) => {
  const statusConditions = [
    { condition: features && features.includes('Early Access'), message: 'early-access' },
    { condition: type === 'dlc', message: 'dlc' },
    { condition: ubisoftSka, message: 'ubisoft' },
    { condition: originSka, message: 'origin' },
    { condition: epicSka, message: 'epic-keys' },
    { condition: !epicSka && validDrm[0] === 'epicgames', message: 'epic-keyless' },
    { condition: validDrm[0] === 'bethesda', message: 'bethesda' },
    { condition: slug === 'catlateral-damage', message: 'vr-update' },
  ];

  return statusConditions
    .filter(({ condition }) => condition)
    .map(({ message }) => message);
};


/**
 * Get the publication age (audio/book) of the product
 * @param {Object} age - Age object from the product (carouselGame)
 * @returns {Number} - Returns the publication audio/book age of the product
 */
const getPublicationAge = (age) => {
  const { book = 0, audio = 0 } = age || {};
  return book || audio;
};

export {
  getStatusMessage,
  getPublicationAge,
};
